import styled from 'styled-components';

import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { ReactNode } from 'react';
import { Tooltip } from '..';

const Container = styled.div<{ borderBottom?: boolean; padded?: boolean; insetValue?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ padded = true, insetValue }) =>
    padded && `${insetValue ? '1.5rem' : '0.75rem'} ${insetValue || '0.75rem'}`};
  padding-bottom: ${({ padded = true }) => padded && `0.25rem`};
  padding-right: ${({ padded = true, insetValue }) => padded && !insetValue && `0.75rem`};

  & .MuiChip-deleteIcon {
    margin-left: 0px !important;
    margin-right: 12px !important;
    font-size: 14px !important;
  }

  & .MuiChip-root {
    border-color: ${({ theme }) => theme.line.light} !important;
    margin-right: 12px !important;
    font-size: 14px !important;
  }

  ${({ theme, borderBottom }) =>
    borderBottom &&
    `
    border-bottom: 1px solid ${theme.line.light};
    padding-bottom: 0.75rem;
    height: calc(55px - 1.5rem);
  `};

  min-height: 35px;

  svg {
    color: ${({ theme }) => theme.text.standard};
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
  }
`;

const Name = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 1rem;

  h1 {
    font-family: 'PPFormula';
    font-size: 16px;
    padding-top: 5px;
    margin: 0;
    color: ${({ theme }) => theme.text.standard};

    max-width: calc(400px - 100px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  p {
    font-family: 'Inter';
    font-size: 14px;
    font-weight: 300;
    color: ${({ theme }) => theme.text.standard};
  }

  svg {
    font-size: 1.9ch;
  }
`;

interface Props {
  title: string;
  icon: ReactNode;
  onClose?: () => void;
  hasTabs?: boolean;
  padded?: boolean;
  insetValue?: string;
}

export const Heading: React.FC<Props> = ({ title, icon, onClose, hasTabs, padded = true, insetValue }) => {
  return (
    <Container borderBottom={!hasTabs} padded={padded} insetValue={insetValue}>
      <Name>
        {icon && <div className='icon'>{icon}</div>}
        <Tooltip placement='top' title={title} arrow>
          <h1>{title}</h1>
        </Tooltip>
      </Name>
      {typeof onClose === 'function' && (
        <IconButton sx={{ borderRadius: '6px' }} size='small' onClick={onClose}>
          <Close />
        </IconButton>
      )}
    </Container>
  );
};
